import { ComponentProps, FC } from 'react';
import UserAvatar from '../UserAvatar/UserAvatar';
import Badge from './Badge';

export const UserBadge: FC<{
  user: ComponentProps<typeof UserAvatar>['user'];
}> = ({ user }) => {
  return (
    <Badge className="pl-1.5" colour="gray" variant="soft">
      <UserAvatar user={user} sizeVariant={'xxs'} borderColourVariant="none" />
      {user.firstName} {user.lastName}
    </Badge>
  );
};
